import { SafeRound } from '../../utils/numberUtils';
import { SumLastDaysFromAnchor } from './SumWindow';

/**
 * Cobertura em dias = estoque / média7d.
 * Usa SEMPRE últimos 7d do anchor (não do período filtrado) porque é métrica
 * de "ritmo recente de venda". Mudar período do preset NÃO muda coverage.
 */
export function Coverage(dailyByDate, ctx, blingQty) {
    if (!ctx?.anchorDateIso) return 0;
    const sales7 = SumLastDaysFromAnchor(dailyByDate, ctx.anchorDateIso, 7);
    const avg7 = sales7 / 7;
    if (avg7 <= 0) return 0;
    return SafeRound(Number(blingQty || 0) / avg7);
}
